// @purpose GLUE
// Tap shield for quiz regions (founder 2026-10-13: "post quiz completion it redirected to research").
// After the last pick the quiz card swaps for a much shorter scoring card, so the page footer slides up
// under the thumb; a second tap (Next pressed while the round auto-advances) then lands on a footer
// link and hx-boost navigates away from the result. For a short moment after a quiz region swaps,
// link taps outside that region are swallowed, and the region keeps its old height until the next
// round or the result has rendered.
const REGIONS = "#wedge-region, #test-region";
const SHIELD_MS = 900;
let until = 0;
let region = null;

function onClick(e) {
  if (Date.now() > until || !region) return;
  const link = e.target.closest && e.target.closest("a[href], button, [hx-get], [hx-post]");
  if (!link || region.contains(link)) return;
  e.preventDefault();
  e.stopImmediatePropagation();
}

export function initTapShield() {
  document.addEventListener("click", onClick, true);
  document.addEventListener("htmx:beforeSwap", (e) => {
    const t = e.detail.target;
    if (!t || !t.matches || !t.matches(REGIONS)) return;
    // hold the height so the footer cannot jump into the thumb zone
    t.style.minHeight = `${t.offsetHeight}px`;
  });
  document.addEventListener("htmx:afterSettle", (e) => {
    const t = e.detail.target;
    if (!t || !t.closest) return;
    const r = t.closest(REGIONS);
    if (!r) return;
    region = r;
    until = Date.now() + SHIELD_MS;
    // the scoring card stays tall until the result replaces it; anything else releases the hold
    if (!r.querySelector(".w-status, [data-scoring]")) setTimeout(() => (r.style.minHeight = ""), SHIELD_MS);
  });
}
